import React from 'react';
import { Container, Row } from 'react-bootstrap';
import igiImg from '../assets/IGI_2.webp';
import giaImg from '../assets/GIA_2.svg';
import { useTranslation } from 'react-i18next';

const Locations = () => {
  const { t } = useTranslation();

  return (
    <section className="py-3">
      <Container className="py-5 text-center" data-aos="zoom-in">
        <h6 className="text-uppercase mb-3" style={{ color: 'var(--color-accent)', letterSpacing: '2px', fontWeight: 'bold' }}>
          {t('certificate.subtitle')}
        </h6>
        <h2 className="display-4 fw-bold text-dark mb-4" style={{ fontFamily: 'var(--font-serif)' }}>
          {t('certificate.title')}
        </h2>
        <p className="text-dark opacity-75 mx-auto mb-5 pb-4" style={{ maxWidth: '600px', lineHeight: '1.8' }}>
          {t('certificate.description')}
        </p>
        
        <Row className="justify-content-center gap-4">
          <img src={igiImg} alt="IGI Certification" className="img-fluid" style={{ maxWidth: '250px' }} />
          <img src={giaImg} alt="GIA Certification" className="img-fluid" style={{ maxWidth: '250px', height: '100px' }} />
        </Row>
      </Container>
    </section>
  );
};

export default Locations;
